import React from 'react';
import { Loader2Icon } from 'lucide-react';
type OkButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
  loading?: boolean;
  loadingLabel?: string;
};
export function OkButton({
  onClick,
  disabled,
  label = 'OK',
  loading,
  loadingLabel = 'Submitting...'
}: OkButtonProps) {
  return <button type="button" onClick={onClick} disabled={disabled || loading} className="inline-flex items-center gap-2 bg-white text-black font-semibold px-5 py-3 rounded-md hover:bg-neutral-200 transition-colors disabled:opacity-40 disabled:cursor-not-allowed" data-id="element-18">
      {loading && <Loader2Icon className="w-4 h-4 animate-spin" data-id="element-19" />}
      {loading ? loadingLabel : label}
    </button>;
}